import { ref, reactive } from 'vue'
export const useLoadingMore = (method) => {
  const lock = ref(false) // 锁定加载更多
  const showLoading = ref(false) // 是否显示loading
  const isLoading = ref(false) // loading status
  const list = ref([]) // 列表
  const totalCount = ref(0) // 总条数
  const finished = ref(false) // 是否全部加载完成
  const loadingFail = ref(false) // 是否加载失败
  const showLoadingMore = ref(false) // 显示加载更多
  const pageParams = reactive(
    // 翻页参数
    {
      page: 1,
      limit: 15
    }
  )

  // 获取列表
  const getList = async () => {
    lock.value = true // 锁定
    // 首次加载显示loading页面
    if (!list.value.length) {
      showLoading.value = true
      isLoading.value = true
    }
    try {
      const { status, data } = await method(pageParams)
      if (status === 200) {
        const { rows, total } = data
        totalCount.value = total
        list.value = list.value.concat(rows)
        // 判断是否全部加载完成
        if (list.value.length >= total) {
          finished.value = true
        }
        // 隐藏loading页面
        showLoading.value = false
        isLoading.value = false
        loadingFail.value = false
      } else {
        // 加载失败
        loadingFail.value = true
        isLoading.value = false
      }
      lock.value = false
      showLoadingMore.value = false
    } catch {
      // 加载失败
      loadingFail.value = true
      showLoadingMore.value = false
      isLoading.value = false
    }
  }

  // 加载更多

  const handleContentScroll = (target) => {
    const { scrollTop, scrollHeight, clientHeight } = target
    const maxH = scrollHeight - clientHeight
    if (Math.ceil(scrollTop) >= maxH && !lock.value && !finished.value) {
      // 滑动到底部并且上一个请求已完成
      // lock.value = true // 锁定
      showLoadingMore.value = true
      pageParams.page += 1
      getList()
    }
  }

  // 重新加载
  const reload = () => {
    loadingFail.value = false
    showLoadingMore.value = true
    getList()
  }
  return {
    getList,
    handleContentScroll,
    reload,
    showLoading,
    isLoading,
    list,
    finished,
    loadingFail,
    pageParams,
    showLoadingMore
  }
}
